import { render, staticRenderFns } from "./LoadSettings.vue?vue&type=template&id=0fb52414&"
import script from "./LoadSettings.vue?vue&type=script&lang=js&"
export * from "./LoadSettings.vue?vue&type=script&lang=js&"
import style0 from "./LoadSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports